module.exports = __webpack_public_path__ + "img/portfolio-01-481x325.4dcef447.jpg";